// moveOutColumn.tsx
import { formatCurrency } from "../../libs/utils";
import { Tag } from "antd";
import { currencyFormat, statusLabel } from "../../../utils/media";
import { formatDate, dateByformat } from "../../../utils/dateHelper";
import React from "react";
import { formatString } from "../../../utils/formatString";

function getDaysBetween(start, end) {
  const startDate: any = new Date(start);
  const endDate: any = new Date(end);
  const msInDay: any = 1000 * 60 * 60 * 24;
  return Math.ceil((endDate - startDate) / msInDay);
}

export const moveOutCol = () => [
  { id: 2, headerName: "Move-out Status", field: "moveOutStatus", checked: true, hide: false },
  { id: 3, headerName: "Property", field: "propertyDetails.propertyName", checked: true, hide: false },
  { id: 4, headerName: "Unit Code", field: "propertyDetails.unitCode", checked: true, hide: false },
  { id: 5, headerName: "Tenant", field: "tenantDetails.tenantNameEN", checked: true, hide: false },
  { id: 6, headerName: "Annual Rent", field: "annualRent", checked: true, hide: false },
  { id: 7, headerName: "Start Date", field: "leaseTerms.leaseStartDate", checked: true, hide: false },
  { id: 8, headerName: "End Date", field: "leaseTerms.leaseEndDate", checked: true, hide: false },
  { id: 9, headerName: "Contract Type", field: "leaseType", checked: true, hide: false },
  { id: 10, headerName: "AWB No", field: "shipmentNumber", checked: true, hide: false },
  { id: 11, headerName: "Owner Name", field: "ownerName", checked: true, hide: false },
  { id: 12, headerName: "Property Admin", field: "adminManager.name", checked: true, hide: false },
  { id: 13, headerName: "Unit Approved Rent", field: "unitApprovedRent", checked: true, hide: false },
  { id: 14, headerName: "Move-out Date", field: "vacatingDate", checked: true, hide: false },
  { id: 15, headerName: "Termination Type", field: "terminationType", checked: true, hide: false },

  // extra hidden fields from leaseCol
  { id: 16, headerName: "Nationality", field: "tenantDetails.nationality", checked: false, hide: true },
  { id: 17, headerName: "Email", field: "tenantDetails.email", checked: false, hide: true },
  { id: 18, headerName: "Marital Status", field: "tenantDetails.maritalStatus", checked: false, hide: true },
  { id: 19, headerName: "Signatory Name", field: "signatoryName", checked: false, hide: true },
  { id: 20, headerName: "Signatory Designation", field: "signatoryDesignation", checked: false, hide: true },
  { id: 21, headerName: "Lease Nature", field: "leaseTerms.leaseNature", checked: false, hide: true },
  { id: 22, headerName: "Lease Executive", field: "leaseManager.name", checked: false, hide: true },
  { id: 23, headerName: "External Agent", field: "externalAgent", checked: false, hide: true },
  { id: 24, headerName: "Occupants", field: "tenantDetails.numberOfOcupants", checked: false, hide: true },
  { id: 25, headerName: "Rent Free Days", field: "leaseTerms.rentFreeDays", checked: false, hide: true },
  { id: 26, headerName: "Rent Free Start", field: "leaseTerms.rentFreeStartDate", checked: false, hide: true },
  { id: 27, headerName: "Rent Free End", field: "leaseTerms.rentFreeEndDate", checked: false, hide: true },
  { id: 28, headerName: "Move-in Date", field: "leaseTerms.moveInDate", checked: false, hide: true },
  { id: 29, headerName: "Ejari Contract No", field: "ejari.contractNumber", checked: false, hide: true },
  { id: 30, headerName: "Bedrooms", field: "propertyDetails.unitSubType", checked: false, hide: true },
  { id: 31, headerName: "Usage Type", field: "propertyDetails.usagesType", checked: false, hide: true },
  { id: 32, headerName: "Built-up Area", field: "propertyDetails.areaSqft", checked: false, hide: true },
  { id: 33, headerName: "Unit Type", field: "unitType", checked: false, hide: true },
  { id: 34, headerName: "Business Unit", field: "businessUnit", checked: false, hide: true },
  { id: 35, headerName: "Is AutoPay Active", field: "isAutoPayActive", checked: false, hide: true },
  { id: 39, headerName: "DEWA", field: "propertyDetails.dewa", checked: false, hide: true },
  { id: 40, headerName: "Address Line 1", field: "propertyDetails.address.addressLine1", checked: false, hide: true },
  { id: 41, headerName: "Address Line 2", field: "propertyDetails.address.addressLine2", checked: false, hide: true },
  { id: 42, headerName: "Community", field: "propertyDetails.address.community", checked: false, hide: true },
  { id: 43, headerName: "Sub Community", field: "propertyDetails.address.subCommunity", checked: false, hide: true },
  { id: 44, headerName: "Security Deposit", field: "leaseTerms.securityDeposit", checked: false, hide: true },
  { id: 45, headerName: "No. Of Installments", field: "bookingTerms.numberOfInstallments", checked: false, hide: true },
  { id: 46, headerName: "Mobile", field: "tenantDetails.mobileNumber", checked: false, hide: true },
  {
    id: 47,
    headerName: "Direct Debit Enabled",
    field: "propertyDetails?.isDirectDebitEnable",
    checked: false,
    hide: true,
  },
  { id: 48, headerName: "Approved Rate", field: "approvedRate", checked: false, hide: true },
  { id: 148, headerName: "ID", field: "recordNumber", checked: false, hide: true },
  { id: 49, headerName: "Actions", field: "action", checked: true, hide: false },
];

export const moveOutColumn = (moveOutColumns, MoreAction, setRenewalStatus, determineTerminationType) => {
  return moveOutColumns.map((col) => {
    if (col.field === "moveOutStatus") {
      return {
        ...col,
        width: 250,
        cellRendererFramework: ({ data }) => (
          <Tag className="tag-sm" color="success">
            {setRenewalStatus(data)}
          </Tag>
        ),
      };
    } else if (col.field === "tenantDetails.tenantNameEN") {
      return { ...col, cellStyle: { textTransform: "capitalize" } };
    } else if (col.field === "annualRent") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          data?.bookingTerms?.annualBaseRent ? (
            <div style={{ position: "absolute", left: "20px" }}>
              {currencyFormat(data.bookingTerms?.annualBaseRent || data.bookingTerms?.renewalAmount)}
            </div>
          ) : (
            ""
          ),
      };
    } else if (col.field === "leaseTerms.leaseStartDate") {
      return {
        ...col,
        minWidth: 150,
        cellRendererFramework: ({ data }) => formatDate(data?.leaseTerms?.leaseStartDate),
      };
    } else if (col.field === "leaseTerms.leaseEndDate") {
      return {
        ...col,
        minWidth: 150,
        sort: "asc",
        cellRendererFramework: ({ data }) => formatDate(data?.leaseTerms?.leaseEndDate),
      };
    } else if (col.field === "leaseType") {
      return { ...col, cellRendererFramework: ({ data }) => statusLabel(data?.leaseType) };
    } else if (col.field === "adminManager.name") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => data?.propertyAdmin || data?.propertyDetails?.propertyAdmin,
      };
    } else if (col.field === "vacatingDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => formatDate(data?.vacatingDate) || "",
      };
    } else if (col.field === "terminationType") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          determineTerminationType(data?.vacatingDate, data?.leaseTerms?.leaseEndDate),
      };
    } else if (col.field === "leaseTerms.rentFreeDays") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          getDaysBetween(data?.leaseTerms?.rentFreeStartDate, data?.leaseTerms?.rentFreeEndDate),
      };
    } else if (col.field === "leaseTerms.rentFreeStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.rentFreeStartDate, "DD-MM-YYYY"),
      };
    } else if (col.field === "leaseTerms.rentFreeEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.rentFreeEndDate, "DD-MM-YYYY"),
      };
    } else if (col.field === "leaseTerms.moveInDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.moveInDate, "DD-MM-YYYY"),
      };
    } else if (col.field === "propertyDetails?.isDirectDebitEnable") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => <span>{data?.propertyDetails?.isDirectDebitEnable ? "Yes" : "No"}</span>,
      };
    } else if (col.field === "leaseTerms.securityDeposit") {
      return {
        ...col,
        type: "rightAligned",
        cellRendererFramework: ({ data }) => formatCurrency(data?.leaseTerms?.securityDeposit),
      };
    } else if (col.field === "action") {
      return {
        ...col,
        maxWidth: 200,
        pinned: "right",
        filter: false,
        cellRendererFramework: MoreAction,
      };
    }
    return col;
  });
};
